export enum ResourceType {
  Wood = 'Wood',
  Sheep = 'Sheep',
  Wheat = 'Wheat',
  Brick = 'Brick',
  Ore = 'Ore',
  Desert = 'Desert',
}

export enum PortType {
  Generic = 'Generic',
  Specific = 'Specific',
}

/** The fixed graph of the board: cells, vertices, edges and their adjacency. */
export interface TopologyCell {
  id: number;
  x: number;
  y: number;
  vertices: number[];
  edges: number[];
  neighbours: number[];
}

export interface TopologyVertex {
  id: number;
  x: number;
  y: number;
  cells: number[];
  edges: number[];
}

export interface TopologyEdge {
  id: number;
  vertices: number[];
  cells: number[];
}

export interface BoardTopology {
  cells: TopologyCell[];
  vertices: TopologyVertex[];
  edges: TopologyEdge[];
}

/** What the board carries this game: each cell's resource and number, the ports. */
export interface CellLayout {
  cellId: number;
  resource: ResourceType;
  number: number | null;
}

export interface PortLayout {
  edgeId: number;
  type: PortType;
  resource: ResourceType | null;
}

export interface BoardLayout {
  cells: CellLayout[];
  ports: PortLayout[];
}
